// API 相关常量
export const API_BASE_URL = '/api/v1'
export const API_TIMEOUT = 300000 // 5 分钟

// 轮询间隔
export const TASK_POLLING_INTERVAL = 20000 // 20 秒

// 积分相关
export const CREDITS_PER_IMAGE = 15
export const TAOTU_CREDITS_PER_IMAGE = 15
export const POSTER_CREDITS = 45

// 图片上传限制
export const MAX_IMAGES = 20
export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp']
export const MAX_IMAGE_SIZE = 10 * 1024 * 1024 // 10 MB
export const MAX_MATERIAL_SIZE = 10 * 1024 * 1024 // 10 MB
export const MAX_MATERIAL_FILES = 4
export const MAX_EXCEL_SIZE = MAX_MATERIAL_SIZE // backwards-compatible alias
export const MATERIAL_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'] as const
export const ACCEPTED_MATERIAL_TYPES = [
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	'application/vnd.ms-excel',
	'text/plain',
	'application/msword',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	'application/pdf',
	...MATERIAL_IMAGE_TYPES,
] as const
export const ACCEPTED_MATERIAL_EXTENSIONS = [
	'.xlsx',
	'.xls',
	'.txt',
	'.doc',
	'.docx',
	'.pdf',
	'.jpg',
	'.jpeg',
	'.png',
	'.webp',
] as const
export const MATERIAL_FILE_ACCEPT = ACCEPTED_MATERIAL_EXTENSIONS.join(',')

// 路由路径
export const ROUTES = {
	HOME: '/',
	LOADING: '/loading',
	ANALYZING: '/analyzing',
	RESULT: '/result',
	AUTH: '/auth',
	ADMIN: '/admin',
	ADMIN_LOG: '/admin/log',
	ERROR_403: '/403',
	ERROR_404: '/404',
} as const

// 步骤名称
export const STEPS = ['上传', '分析', '选择', '生成', '完成']

// 任务状态文本映射
export const TASK_STATUS_TEXT: Record<string, string> = {
	pending: '准备中...',
	analyzing: 'AI分析图片中...',
	reanalyzing: '重新分析图片中...',
	generating_whitebg: '白底图生成中...',
	analysis_complete: '分析完成',
} as const

// 列表页状态显示文本（短文本）
export const TASK_STATUS_LABEL: Record<string, string> = {
	pending: '等待中',
	analyzing: '分析中',
	reanalyzing: '重新分析中',
	generating_whitebg: '生成白底图',
	selecting_skill: '选择技能中',
	analyzing_combo: '分析套图',
	composing: '合成中',
	analysis_complete: '分析完成',
	completed: '已完成',
	failed: '失败',
	cancelled: '已取消',
} as const

// 处理中的任务状态
export const PROCESSING_STATUSES = [
	'pending',
	'analyzing',
	'reanalyzing',
	'generating_whitebg',
] as const

// 分析阶段的状态
export const ANALYSIS_STATUSES = ['analyzing', 'reanalyzing', 'analysis_complete'] as const

// 完成状态
export const TERMINAL_STATUSES = ['completed', 'failed', 'cancelled', 'analysis_complete'] as const

// 套图图片语言配置
export interface TaotuLanguage {
	code: string
	name: string
	direction: 'ltr' | 'rtl'
}

export const TAOTU_LANGUAGES: TaotuLanguage[] = [
	{ code: 'zh-CN', name: '简体中文', direction: 'ltr' },
	{ code: 'zh-TW', name: '繁体中文', direction: 'ltr' },
	{ code: 'en', name: '英文', direction: 'ltr' },
	{ code: 'ja', name: '日语', direction: 'ltr' },
	{ code: 'ko', name: '韩语', direction: 'ltr' },
	{ code: 'hi', name: '印地语', direction: 'ltr' },
	{ code: 'ar', name: '阿拉伯语', direction: 'rtl' },
	{ code: 'fr', name: '法语', direction: 'ltr' },
	{ code: 'de', name: '德语', direction: 'ltr' },
	{ code: 'ru', name: '俄语', direction: 'ltr' },
	{ code: 'es', name: '西班牙语', direction: 'ltr' },
	{ code: 'pt', name: '葡萄牙语', direction: 'ltr' },
] as const

export const TAOTU_DEFAULT_LANGUAGE: TaotuLanguage = TAOTU_LANGUAGES[0]

// LocalStorage keys
export const STORAGE_KEYS = {
	TOKEN: 'token',
} as const
